
/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */

import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { DraggableDirective } from "app/directives/draggable.directive";

/** Add variable $ for bootstrap support. */
declare var $: any;

@Component({
  selector: 'ef-set-affiliate-dialog',
  templateUrl: './set-affiliate-dialog.component.html',
  styleUrls: ['./set-affiliate-dialog.component.css']
})
export class SetAffiliateDialogComponent {

  /** Draggable Directive added to that the popup is draggable.  Referenced so that the position can be reset. */
  @ViewChild(DraggableDirective) draggableDirective: DraggableDirective;

  @Input()
  possibleAffiliates: string[];

  selectedAffiliate: string = null;

  @Output() updateClicked = new EventEmitter<string>();

  uiDisabled = false;

  public show(selectedAffiliate: string): void {
    if (selectedAffiliate != null && selectedAffiliate.length > 0) {
      this.selectedAffiliate = selectedAffiliate;
    } else {
      this.selectedAffiliate = null;
    }

    this.uiDisabled = false;
    
    this.draggableDirective.reset();  // Reset the Draggable Directive so that the Dialog pops up in the same original place
    $("#setAffiliateDialog").show();
  }

  public hide(): void {
    $("#setAffiliateDialog").hide();
  }

  public update(): void {
    this.updateClicked.emit(this.selectedAffiliate);
  }





}